import { queryOptions } from "../../client.ts";

export function odataMetadataQueryOptions() {
    return queryOptions("get", "/bff/odata/metadata", {});
}
